import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const PreRegistration = props => (
  <SvgIcon {...props}>
    <g>
      <path d="M19.5,22c1.4,0,2.5-1.1,2.5-2.5v-3.4L16.1,22H19.5z" />
      <path
        d="M19.5,2h-15C3.1,2,2,3.1,2,4.5v15C2,20.9,3.1,22,4.5,22h11.6v-3.4c0-1.4,1.1-2.5,2.5-2.5H22V4.5C22,3.1,20.9,2,19.5,2z
        M13.2,13.2H5.8v-2.5h7.5V13.2z M18.2,8.3H5.8V5.8h12.5V8.3z"
      />
    </g>
  </SvgIcon>
)

export default PreRegistration



// WEBPACK FOOTER //
// ./src/icons/PreRegistration.js